<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <div class="flex justify-content-between align-items-center">
                    <h3 v-if="mappingShift && !mappingShift.jam_absen">Absen Masuk</h3>
                    <h3 v-if="mappingShift && mappingShift.jam_absen && !mappingShift.jam_pulang">
                        Absen Pulang
                    </h3>
                    <Button
                        v-if="mappingShift && mappingShift.status_absen !== 'Pulang'"
                        :loading="isLoading"
                        :label="
                            checkedOnImage
                                ? 'Matikan Kamera'
                                : 'Nyalakan Kamera'
                        "
                        :class="`p-button-${
                            checkedOnImage ? 'success' : 'danger'
                        } p-button-raised b-button-outlined`"
                        @click="setCamera"
                    />
                </div>
                <div
                    v-if="mappingShift"
                    class="flex align-items-center flex-column col-lg-12 mx-auto"
                >
                    <h5>Tanggal Shift : {{ datestamp }}</h5>
                </div>
                <div
                    v-if="mappingShift"
                    class="flex align-items-center flex-column col-lg-12 mx-auto"
                >
                    <h5>
                        Shift : {{ mappingShift.shift.nama_shift }} (
                        {{ mappingShift.shift.jam_masuk }} -
                        {{ mappingShift.shift.jam_keluar }} )
                    </h5>
                </div>
                <div
                    class="flex align-items-center flex-column col-lg-12 mx-auto"
                >
                    <Button
                        label="Lihat Lokasi Saya"
                        @click="modelDialog = true"
                    />
                </div>
                <div
                    class="flex align-items-center flex-column col-lg-12 mx-auto"
                >
                    <h5>Waktu Sekarang {{ time }}</h5>
                </div>
                <div
                    v-if="
                        mappingShift && mappingShift.status_absen !== 'Pulang'
                    "
                    class="field grid"
                >
                    <div
                        id="camera"
                        class="flex align-items-center flex-column col-lg-6 mx-auto"
                    >
                        <div class="col-12 md:col-12 w-100">
                            <video
                                v-show="!isPhotoTaken"
                                ref="camera"
                                style="width: 100%"
                                autoplay
                            ></video>
                            <canvas
                                v-show="isPhotoTaken"
                                id="photoTaken"
                                ref="canvas"
                                style="width: 100%; height: 400px"
                            ></canvas>
                        </div>
                        <div class="col-2 text-center my-2">
                            <Button
                                v-if="!isPhotoTaken"
                                class="p-button-lg p-button-rounded"
                                icon="pi pi-camera"
                                @click="takePhoto"
                            />
                            <Button
                                v-if="isPhotoTaken"
                                class="p-button-lg p-button-rounded"
                                icon="pi pi-refresh"
                                @click="takePhoto"
                            />
                        </div>
                        <div class="col-6 text-center">
                            <Button
                                v-if="isPhotoTaken"
                                :loading="isSaving"
                                @click="save"
                                id="button1"
                                label="Save"
                            />
                        </div>
                    </div>
                </div>

                <div
                    v-if="
                        !mappingShift || mappingShift.status_absen === 'Pulang'
                    "
                    class="surface-0 flex align-items-center justify-content-center overflow-hidden"
                >
                    <div
                        class="grid justify-content-center p-2 lg:p-0"
                        style="min-width: 80%"
                    >
                        <div
                            class="col-12 xl:col-6"
                            style="
                                border-radius: 56px;
                                padding: 0.3rem;
                                background: linear-gradient(
                                    180deg,
                                    rgba(233, 30, 99, 0.4) 10%,
                                    rgba(33, 150, 243, 0) 30%
                                );
                            "
                        >
                            <div
                                class="h-full w-full m-0 py-7 px-4"
                                style="
                                    border-radius: 53px;
                                    background: linear-gradient(
                                        180deg,
                                        var(--surface-50) 38.9%,
                                        var(--surface-0)
                                    );
                                "
                            >
                                <div
                                    class="grid flex flex-column align-items-center"
                                >
                                    <div
                                        class="flex justify-content-center align-items-center bg-pink-500 border-circle"
                                        style="height: 3.2rem; width: 3.2rem"
                                    >
                                        <i
                                            class="pi pi-fw pi-exclamation-circle text-2xl text-50"
                                        ></i>
                                    </div>
                                    <h1
                                        class="font-bold text-5xl text-900 mb-2"
                                    >
                                        <div
                                            v-if="
                                                mappingShift &&
                                                mappingShift.status_absen ===
                                                    'Pulang'
                                            "
                                        >
                                            Terima Kasih sudah absen pada hari
                                            ini
                                        </div>
                                        <div v-else>Bukan Shift Anda</div>
                                    </h1>
                                    <div
                                        v-if="
                                            mappingShift &&
                                            mappingShift.status_absen ===
                                                'Pulang'
                                        "
                                    >
                                        <span class="text-600"
                                            >Sempai Jumpa di shift
                                            selanjutnya</span
                                        >
                                    </div>
                                    <div v-else>
                                        <span class="text-600"
                                            >Silahkan Hubungi Pihak Perusahaan
                                            Jika Terjadi Kesalahan Shift</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Dialog
        v-model:visible="modelDialog"
        :style="{ width: '450px' }"
        :header="'Lokasi Saya'"
        :modal="true"
        class="p-fluid"
    >
        <div class="field">
            <div style="width: 100%; height: 320px">
                <l-map
                    ref="map"
                    v-model="zoom"
                    v-model:zoom="zoom"
                    :center="[form.latitude, form.longitude]"
                >
                    <l-tile-layer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    ></l-tile-layer>
                    <l-marker
                        visible
                        :lat-lng.sync="{
                            lat: String(form.latitude),
                            lng: String(form.longitude),
                        }"
                    >
                        <l-popup>Anda Ada Disini !</l-popup>
                    </l-marker>

                    <l-marker
                        v-if="designatedLocation.latitude !== 0 && designatedLocation.longitude !== 0"
                        visible
                        :lat-lng.sync="{
                            lat: designatedLocation.latitude,
                            lng: designatedLocation.longitude
                        }"
                    >
                        <l-popup openUp>{{ designatedLocation.name }}</l-popup>
                    </l-marker>
                    <l-circle
                        v-if="designatedLocation.latitude !== 0 && designatedLocation.longitude !== 0"
                        :lat-lng="{ lat: designatedLocation.latitude, lng: designatedLocation.longitude }"
                        :radius="designatedLocation.radius"
                        color="green"
                    >
                    </l-circle>
                </l-map>

            </div>
            Address :
            {{ form.address.display_name }}
        </div>
        <template #footer>
            <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                @click="modelDialog = false"
            />
        </template>
    </Dialog>
</template>
<script>
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import InputText from "primevue/inputtext";
import AutoComplete from "primevue/autocomplete";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AppLayout from "../../Layouts/AppLayout";
import axios from "axios";
// maps
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LCircle,
} from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";
import FlashMessage from "../../Services/FlashMessage";
import { v4 as uuidv4 } from 'uuid';

export default {
    layout: AppLayout,
    components: {
        Dropdown,
        Dialog,
        Calendar,
        Checkbox,
        InputText,
        AutoComplete,
        Button,
        TabView,
        TabPanel,
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LCircle,
    },
    mixins: [FlashMessage],
    data() {
        return {
            form: this.$page.props.attendance ?? {
                employee_id: "",
                is_present: false,
            },
            designatedLocation: this.$page.props.mapping_shift ? this.$page.props.mapping_shift.user.employee.salary.placement : { latitude: 0, longitude: 0},
            checkedOnImage: false,
            submitted: false,
            selectedAutoValue: this.$page.props.attendance
                ? this.$page.props.attendance.employee
                : "",
            isSelected: false,
            isSaving: false,
            isEdit: false,
            deviceId: null,
            img: null,
            camera: null,
            devices: [],
            reasons: [
                "Ijin Khusus",
                "Ijin Setengah Hari Kerja",
                "Dinas Luar",
                "Pulang Cepat",
                "Sakit Surat Dokter",
                "Cuti",
                "Sakit Tanpa Surat Dokter",
                "Tidak Ada Izin",
            ],
            mappingShift: this.$page.props.mapping_shift,
            // is camera setting
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            user: null,
            interval: null,
            datestamp: null,
            time: null,
            // Maps
            model: [],
            modelDialog: false,
            zoom: 12,
            iconUrl:
                "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/marker-icon.png",
            isLoading: false,
        };
    },
    beforeUnmount() {
        this.cameraOff();
        clearInterval(this.interval);
    },
    created() {
        setInterval(this.getNow, 1000);
    },
    mounted() {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                let address = '';

                axios
                .get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`)
                .then((data) => {
                    address = data.data;
                    console.log(latitude);

                    return (this.form = {
                        ...this.form,
                        latitude,
                        longitude,
                        address,
                    });
                })
            },
            (error) => {
                this.flashError("GPS Tidak Aktif, Pastikan browser sudah diizinkan untuk mengakses gps serta gps telah dinyalakan");
            }
        );

        if (this.$page.props.attendance) {
            this.isEdit = true;
        }
        this.getUser();

        // update the time every second
        this.interval = setInterval(() => {
            // Concise way to format time according to system locale.
            // In my case this returns "3:48:00 am"
            const today = new Date();
            const date =
                today.getDate() +
                " " +
                (today.getMonth() + 1) +
                " " +
                today.getFullYear();
            this.datestamp = date;

            this.time = Intl.DateTimeFormat("id-ID", {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            }).format();
        }, 1000);




        this.$nextTick(() => {

        })
    },
    methods: {
        save() {
            this.form.employee_id = this.selectedAutoValue.id;
            let photoTaken = document
                .getElementById("photoTaken")
                .toDataURL("image/jpeg");

            const date = new Date();
            let type = "masuk";

            let formData = new FormData();
            formData.append('shift_id', this.mappingShift.id);
            formData.append(
                "jam_absensi",
                `${date.getHours()}:${date.getMinutes()}`
            );

            const { latitude, longitude } = this.form;
            if(!latitude || !longitude){
                this.flashError("Data GPS Tidak Ditemukan, pastikan internet serta gps anda menyala dan sudah diizinkan");
                return false;
            }

            formData.append('lat_absensi', latitude);
            formData.append('long_absensi', longitude);
            formData.append('is_outside_location', this.form.is_outside_location);

            photoTaken = new Blob([photoTaken], { type: "image/jpeg" });
            if(!photoTaken){
                this.flashError("Foto Tidak Berhasil Dicapture, pastikan camera anda berfungsi dengan baik dan sudah diizinkan ");
                return false;
            }

            formData.append(
                "image",
                photoTaken,
                `image-${uuidv4()}.jpeg`
            );

            if(this.mappingShift){
                if(!this.mappingShift.jam_absen){
                    type = "masuk"
                }
                if(this.mappingShift.jam_absen && !this.mappingShift.jam_pulang){
                    type = "keluar"
                }
            }else{
                this.flashError("Bukan Jadwal Anda Hari ini");
                return false;
            }

            axios
                .post(this.route(`absensi.${type}`, this.user.id), formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((data) => {
                    this.cameraOff();
                    document.location.href = this.route(
                        "attendance-views.index"
                    );
                })
                .catch((error) => {
                    this.flashError(error.message, "Error")
                });

            this.isSaving = false;
            this.submitted = false;
        },
        setCamera() {
            const user = {lat: this.form.latitude, lng: this.form.longitude};
            const office = {lat: parseFloat(this.designatedLocation.latitude), lng: parseFloat(this.designatedLocation.longitude)};

            const currentLocationInArea = this.arePointsNear(user, office, this.designatedLocation.radius / 1000)

            if(!currentLocationInArea){
                this.flashError("Anda Berada Diluar Radius Absen, Cek Kembali Lokasi Anda !");
                return;
            }

            if (!this.checkedOnImage) {
                this.createCameraElement();
                return;
            }
            this.cameraOff();
            return;
        },
        createCameraElement() {
            const constraints = (window.constraints = {
                audio: false,
                video: true,
            });

            const mediaDevices = navigator.mediaDevices;
            if(mediaDevices){
                mediaDevices
                .getUserMedia(constraints)
                .then((stream) => {
                    this.isLoading = false;
                    this.$refs.camera.srcObject = stream;
                    this.checkedOnImage = true;
                })
                .catch((error) => {
                    this.isLoading = false;
                    alert(
                        "May the browser didn't support or there is some errors."
                    );
                });
            }else{
                this.flashError("Camera Error, Pastikan kamera sudah diizinkan untuk akses via browser. Jika Tidak cek kembali perangkat kamera anda");
            }
        },
        cameraOff() {
            const stream = this.$refs.camera.srcObject;
            if (stream) {
                const tracks = stream.getTracks();
                tracks.forEach((track) => {
                    track.stop();
                });
                this.$refs.camera.srcObject = null;
            }
            this.checkedOnImage = false;
        },
        takePhoto() {
            if(!this.checkedOnImage){
                alert(
                    "Kamera tidak menyala, Silahkan Nyalakan Kamera Terlebih dahulu"
                );

                return false;
            }

            if (!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                    this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }

            this.isPhotoTaken = !this.isPhotoTaken;

            const context = this.$refs.canvas.getContext("2d");

            this.$refs.canvas.width = 449.2;
            this.$refs.canvas.height = 336.9;
            context.drawImage(this.$refs.camera, 0, 0, 449.2, 336.9);
            this.img = this.$refs.camera;
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n) {
                u8arr[n - 1] = bstr.charCodeAt(n);
                n -= 1; // to make eslint happy
            }
            return new File([u8arr], filename, { type: mime });
        },
        // Check for Current Location With Office Location
        // https://stackoverflow.com/a/50405147
        arePointsNear(checkPoint, centerPoint, km) {
            var ky = 40000 / 360;
            var kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
            var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
            var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
            return Math.sqrt(dx * dx + dy * dy) <= km;
        },
        getUser() {
            this.user = JSON.parse(sessionStorage.getItem("auth:me"));
        },
    },
};
</script>

<style>
canvas {
    object-fit: contain;
}
</style>
